import { render, staticRenderFns } from "./messagelog.vue?vue&type=template&id=5cb9dfb0&scoped=true"
import script from "./messagelog.vue?vue&type=script&lang=js"
export * from "./messagelog.vue?vue&type=script&lang=js"
import style0 from "./messagelog.vue?vue&type=style&index=0&id=5cb9dfb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9dfb0",
  null
  
)

export default component.exports